var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuarantee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    fill: "#3377EF",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6148 18.4572C32.2679 17.8476 33.3268 17.8476 33.9799 18.4572L38.1608 22.3594C38.4744 22.6522 38.6506 23.0492 38.6506 23.4632C38.6506 23.8772 38.4744 24.2743 38.1608 24.567L33.9799 28.4692C33.3268 29.0788 32.2679 29.0788 31.6148 28.4692C30.9617 27.8596 30.9617 26.8713 31.6148 26.2617L32.8828 25.0782C26.9661 25.6256 22.3448 30.2847 22.3448 35.9512C22.3448 41.9859 27.5862 46.878 34.0517 46.878C40.0203 46.878 44.948 42.7075 45.6679 37.319C45.7822 36.4636 46.6178 35.8565 47.5344 35.9632C48.4509 36.0699 49.1013 36.8499 48.987 37.7053C48.0609 44.6371 41.7286 50 34.0517 50C25.7389 50 19 43.7101 19 35.9512C19 28.5291 25.1665 22.4512 32.9785 21.9376L31.6148 20.6648C30.9617 20.0552 30.9617 19.0668 31.6148 18.4572ZM41.0877 30.945C41.7408 31.5546 41.7408 32.543 41.0877 33.1526L33.5618 40.1769C32.9087 40.7865 31.8498 40.7865 31.1967 40.1769L27.8519 37.055C27.1988 36.4454 27.1988 35.457 27.8519 34.8474C28.505 34.2378 29.5639 34.2378 30.217 34.8474L32.3793 36.8656L38.7225 30.945C39.3756 30.3354 40.4345 30.3354 41.0877 30.945Z",
    fill: "#3377EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default __webpack_public_path__ + "static/media/guarantee.b78d36393e77310f90a645c90abbe4b8.svg";
export { ForwardRef as ReactComponent };